import { SET_PRODUCT_SEARCH } from './../const';

export default (searchString) => {
    return {type: SET_PRODUCT_SEARCH, searchString}
}
